import React from 'react';
import {useRouter} from 'next/router';
import {getLocaleContent} from '@helper/locale-content.js';
import BreadcrumbNav from '@components/common/BreadcrumbNav/index.js';
import {HomeOutlined} from '@ant-design/icons';

function NewsNavPromotion() {
    const {locale} = useRouter();

    return (
        <div>
            <BreadcrumbNav
                items={[
                    {label: '', href: '/', icon: <HomeOutlined />},
                    {
                        label: getLocaleContent(locale, 'page.promotion-page.breadcrumb-title'),
                        href: '/uu-dai',
                        color: '#006940',
                    },
                ]}
            />
        </div>
    );
}

export default NewsNavPromotion;
